import React, { useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Polygon, InfoWindow } from 'google-maps-react'
import { FaGlobeAmericas } from 'react-icons/fa'

import Page from 'components/common/Page'
import Map from 'components/common/Map'
import Card from 'components/common/cards/Card'
import Subtitle from 'components/common/Subtitle'
import ReadyToSignupBlock from 'components/common/blocks/ReadyToSignupBlock'
import BlockTitle from 'components/common/blocks/BlockTitle'

import colors from 'utility/colors'
import { mapCenter } from 'utility/constants'
import { center } from 'utility/mapping'
import { useAllCounties } from 'hooks/api/counties/useAllCounties'
import { useTenantProfile } from 'hooks/api/tenant/useTenantProfile'

const CoveragePage = () => {
	const { data: counties } = useAllCounties()
	const { data: tenantProfile } = useTenantProfile()

	const [infoWindow, setInfoWindow] = useState(null)

	const activeCounties = counties?.filter((county) =>
		tenantProfile?.countyIds?.includes(county?.countyId),
	)

	console.log('activeCounties', activeCounties)

	const geoPolygonCoords = activeCounties?.map((county) => {
		const countyGeo = county?.geo
		const coords =
			countyGeo?.features?.length && countyGeo?.features?.[0]?.geometry?.coordinates?.[0][0]

		const polyCoords =
			coords &&
			coords.length &&
			coords.map((cord) => {
				return {
					lat: cord[1],
					lng: cord[0],
				}
			})
		return polyCoords
	})

	const title = `Coverage`
	const description = `Serving homeowners across the great state of Texas with professional property tax service`

	return (
		<Page title={title} description={description} wedge footer paddingTop={50} fluid>
			<Container>
				<Row>
					<Col>
						<BlockTitle
							cardStyle={{ padding: 30, marginTop: 20 }}
							titleStyle={{ fontSize: 40 }}
							rowStyle={{ alignItems: 'center' }}
							background={colors.FOOTER}
							title={`Coverage`}
							text={description}
							icon={FaGlobeAmericas}
							iconStyle={{ fontSize: 60 }}
						/>
						<Card
							style={{ height: 500, padding: 0, margin: 0, overflow: 'hidden' }}
							className='map-container'
						>
							<Map
								initialCenter={mapCenter}
								containerStyle={{
									position: 'relative',
									width: '100%',
									height: '100%',
								}}
								style={{ width: '100%', height: '100%', opacity: 0.7 }}
								zoomControl={true}
								scaleControl={true}
								draggable={true}
								zoom={6}
							>
								{geoPolygonCoords &&
									geoPolygonCoords.map((polygonCord, index) => {
										const polyCoordCounty = activeCounties?.[index]
										let slug = polyCoordCounty?.name?.toLowerCase().split(' ').join('-')

										return (
											<Polygon
												key={index}
												paths={polygonCord}
												strokeColor='#ffffff'
												strokeOpacity={0.8}
												onMouseover={(e) => {
													// Get center of paths here
													const centerOfPaths = center(
														e?.paths.map((coords) => {
															return [coords?.lat, coords?.lng]
														}),
													)
													setInfoWindow({
														...infoWindow,
														slug,
														title: polyCoordCounty?.name,
														coords: {
															lat: centerOfPaths[0],
															lng: centerOfPaths[1],
														},
													})
												}}
												onMouseout={(e) => {
													setInfoWindow(null)
												}}
												strokeWeight={1}
												fillColor={colors.PRIMARY}
												fillOpacity={0.5}
											></Polygon>
										)
									})}
								<InfoWindow visible={infoWindow} position={infoWindow?.coords}>
									<Subtitle style={{ fontSize: 16, padding: 0, margin: 0 }}>
										{infoWindow?.title} County
									</Subtitle>
								</InfoWindow>
							</Map>
						</Card>
					</Col>
				</Row>

				<Card style={{ marginTop: 20 }}>
					{activeCounties?.map((county, index) => {
						const isLast = counties.length - 1 == index
						return (
							<Subtitle style={{ display: 'inline-block', paddingRight: 5 }}>
								{county?.name}
								{isLast ? '' : ','}
							</Subtitle>
						)
					})}
				</Card>
			</Container>
			<ReadyToSignupBlock
				titleContainerStyle={{ marginTop: 0, marginBottom: 20 }}
				containerStyle={{ marginTop: 60, marginBottom: 50 }}
			/>
		</Page>
	)
}

export default CoveragePage
